import { Dispatch } from 'redux';
import { GetVisitConcepts } from '../../services/VisitConcepts.Services';
import {
    VISIT_CONCEPTS_REQUEST,
    VISIT_CONCEPTS_SUCCESS,
    VISIT_CONCEPTS_FAILURE,
    VISIT_CONCEPTS_CLEAR,
    VisitConceptsActionTypes
} from '../actions/VisitConcepts.Actions';
import { AppState } from '../reducers';
import { ErrorType } from '../../models/HttpError';


export const actionCreators = {
    getVisitConcepts: (
        protocolId: number,
        visitId: number,
        patientId: string
    ) => async (dispatch: Dispatch<VisitConceptsActionTypes>, getState: () => AppState) => {
        const state = getState();
        let token = '';
        if (state.oidc?.user) {
            token = state.oidc.user.access_token;
        } else {
            dispatch({
                type: VISIT_CONCEPTS_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Unauthorized. Please log in again.',
                    Errors: []
                },
                isLoading: false,
                isLoadingSuccess: false,
                failLoading: true
            });
            return;
        }
        dispatch({
            type: VISIT_CONCEPTS_REQUEST,
            protocolId,
            visitId,
            patientId,
            isLoading: true,
            isLoadingSuccess: undefined,
            failLoading: false
        });
        try {
            const data = await GetVisitConcepts(protocolId, visitId, patientId, token);
            dispatch({
                type: VISIT_CONCEPTS_SUCCESS,
                payload: data,
                isLoading: false,
                isLoadingSuccess: true,
                failLoading: false
            });
        } catch (error) {
            let typedError: ErrorType;
            if (
                typeof error === 'object' &&
                error !== null &&
                'ErrorCode' in error &&
                'ErrorMessage' in error &&
                'Errors' in error
            ) {
                // If error matches ErrorType shape
                typedError = error as ErrorType;
            } else {
                typedError = {
                    ErrorCode: 500,
                    ErrorMessage: String(error) || 'Unknown error occurred',
                    Errors: []
                };
            }
            dispatch({
                type: VISIT_CONCEPTS_FAILURE,
                error: typedError,
                isLoading: false,
                isLoadingSuccess: false,
                failLoading: true
            });
        }
    },
    clearVisitConcepts: (): VisitConceptsActionTypes => ({
        type: VISIT_CONCEPTS_CLEAR
    })
};
